export const WHOOP_CART_COOKIE_NAME = 'whoop-cart';
export const PROMO_CODE_COOKIE_NAME = 'promo-code';
export const WHOOP_AUTH_TOKEN_COOKIE_NAME = 'whoopauth.accessToken';
export const WHOOP_ENCODED_LEGACY_IOS_COOKIE_NAME = 'whoop.encoded.legacy.ios';
export const WHOOP_LEGACY_IOS_COOKIE_NAME = 'whoop.legacy.ios';
export const WHOOP_REGIONALIZED_PATH_COOKIE_NAME = 'Whoop-Regionalized-Path';
export const WHOOP_REGION_CODE_COOKIE_NAME = 'Whoop-Region';
export const WHOOP_HEADER_COUNTRY_COOKIE_NAME = 'Whoop-Header-Country';
